import { KeyboardCode } from '@dnd-kit/core'

// dnd-kit's default KeyboardSensor coordinateGetter nudges the drag position by a fixed 25px
// per keypress. Household containers in this single-column layout are often taller than that,
// so a much larger step is used here to keep the number of arrow-key presses reasonable.
const STEP = 100

/**
 * dnd-kit `KeyboardSensor` coordinateGetter for the Edit Households panel.
 *
 * Mirrors dnd-kit's own default coordinateGetter (same incremental-delta shape, so it keeps
 * working correctly with dnd-kit's built-in auto-scroll-near-viewport-edge behavior) but with a
 * larger step size tuned to this panel's household container heights.
 */
export const householdKeyboardCoordinateGetter = (event, { currentCoordinates }) => {
  switch (event.code) {
    case KeyboardCode.Right:
      return { ...currentCoordinates, x: currentCoordinates.x + STEP }
    case KeyboardCode.Left:
      return { ...currentCoordinates, x: currentCoordinates.x - STEP }
    case KeyboardCode.Down:
      return { ...currentCoordinates, y: currentCoordinates.y + STEP }
    case KeyboardCode.Up:
      return { ...currentCoordinates, y: currentCoordinates.y - STEP }
    default:
      return undefined
  }
}
